<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            <CCol md="6" lg="6" xl="6"> Historial de bonos </CCol>
            <CCol md="6" lg="6" xl="6">
              <router-link :to="{ name: 'Bono', params: { config: config } }" class="float-right">
                <CButton color="primary" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-arrow-thick-left" />
                  Regresar
                </CButton>
              </router-link>

              <CButton style="margin-bottom: 10px; height: 35px;" @click="successModalBono = true" color="primary" class="float-right mr-1 btn-header">
                Limpiar tabla
              </CButton>
            </CCol>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="items"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
              class="table-masiva"
            >
              <template #clonar="{index: pos}">
                <th
                  style="padding: 10px 5px 5px 5px;"
                  :class="buscarError(pos)"
                >
                  <div class="popUp" v-show="errores[pos].showpop">
                    <span>{{ mensajeError(pos) }}</span>
                  </div>
                  <CButton
                    tabindex="-1"
                    style="width: 20px; height: 20px; padding: 1px;"
                    color="ghost-light"
                    @click="copyAll(pos)"
                    square
                    size="sm"
                  >
                    <!-- <CIcon style="width:10px; margin: 0px;" name="cil-copy" /> -->
                    <img
                      style="width:15px; height: 15px;"
                      src="../../assets/icons/copy.png"
                      class="imagen"
                    />
                  </CButton>
                  <CButton
                    tabindex="-1"
                    style="width: 20px; height: 20px; padding: 1px; margin-top:15px;"
                    color="warning"
                    v-show="
                      errores[pos] ? (errores[pos].fail ? true : false) : false
                    "
                    @click="()=>mostrarPop(pos)"
                    square
                    size="sm"
                  >
                    <CIcon
                      style="width:10px; margin: 0px;"
                      name="cil-warning"
                    />
                  </CButton>
                </th>
              </template>
              <template #fechahora="{item, index: pos}">
                <td :class="buscarError(pos)" style="position:relative;">
                  <div class="d-flex align-items-top flex-wrap flex-sm-nowrap">
                    <CInput
                      v-model="item.fechahora"
                      type="date"
                      :horizontal="{ input: 'input-130' }"
                      invalidFeedback="Campo requerido"
                      v-if="!sending[pos]"
                    />
                    <span v-else>
                      {{moment(item.fechahora,'YYYY-MM-DD 00:00:00').format('DD/MM/YYYY')}}
                    </span>
                    <div class="btn-group flex-column">
                      <div class="divUbi">
                        <CButton

                          v-c-tooltip="{
                            content:
                              'Copiar la fecha en las filas vacías hasta donde haya una fila con información',
                            placement:
                              pos == items.length - 1 ? 'left-end' : 'left'
                          }"
                          tabindex="-1"
                          class="buttonClonarUbi"
                          @click="clonarCelda(pos, 'fechahora')"
                          color="ghost-light"
                          square
                          size="sm"
                        >
                          <img
                            style="width:13px; height: 13px;"
                            src="../../assets/icons/down.png"
                            class="imagen"
                          />
                        </CButton>
                      </div>
                    </div>
                  </div>
                </td>
              </template>
              <template #trabajador_id="{item, index: pos}">
                 <td :class="buscarError(pos)" style="position:relative;">
                  <div class="d-flex align-items-top flex-wrap flex-sm-nowrap">
                    <Treeselect
                      v-model="item.trabajador_id"
                      :options="trabajadores"
                      placeholder="Selecciona un trabajador"
                      title="Selecciona un trabajador"
                      v-if="!sending[pos]"
                    >
                    </Treeselect>
                    <span v-else>
                      {{trabajadores.find(f=>f.id === item.trabajador_id).label||''}}
                    </span>
                    <CButton v-c-tooltip="{
                        content: 'Copiar el trabajador en las filas vacías hasta donde haya una fila con información',
                        placement: 'right',
                      }" tabindex="-1" class="buttonClon" @click="clonarCelda(pos, 'trabajador_id')" color="ghost-light" square size="sm">
                      <img style="width:13px; height: 13px;" src="../../assets/icons/down.png" class="imagen" >
                    </CButton>
                  </div>
                </td>
              </template>
              <template #ubicaciones="{item, index: pos}">
                <td :class="buscarError(pos)" style="position:relative;">
                  <div class="d-flex align-items-top flex-wrap flex-sm-nowrap">
                    <multiselect
                      style="width: 120px; height: 1px;"
                      v-model="item.ubicaciones"
                      :options="ubicaciones"
                      :multiple="true"
                      selectLabel=""
                      deselectLabel=""
                      label="label"
                      :loading="isLoadingPage"
                      selectedLabel=""
                      track-by="label"
                      placeholder="Selecciona una o varias ubicaciones"
                      :close-on-select="false"
                      :clear-on-select="false"
                      title="Selecciona una o varias ubicaciones"
                      v-if="!sending[pos]"
                    >
                      <template #no-options>Sin resultados.</template>
                      <template slot="selection" slot-scope="{ values, isOpen }"
                        ><span
                          class="multiselect__single"
                          v-if="values.length > 1 && !isOpen"
                          >{{ values.length }} ubicaciones</span
                        ></template
                      >
                    </multiselect>
                    <span v-else>
                      {{item.ubicaciones.map(m=>m.label).join(', ')}}
                    </span>
                    <div class="btn-group flex-column">
                      <CButton
                        tabindex="-1"
                        @click="obtenerUbicaciones(pos)"
                        color="ghost-light"
                        class="buttonUbi btnUbi2"
                        square
                        size="sm"
                      >
                        <img
                          style="width:15px; height: 15px;"
                          src="../../assets/icons/file.png"
                          class="imagen"
                        />
                      </CButton>
                      <div class="divUbi">
                        <CButton

                          v-c-tooltip="{
                            content:
                              'Copiar la ubicación en las filas vacías hasta donde haya una fila con información',
                            placement:
                              pos == items.length - 1 ? 'left-end' : 'left'
                          }"
                          tabindex="-1"
                          class="buttonClonarUbi"
                          @click="clonarCelda(pos, 'ubicaciones')"
                          color="ghost-light"
                          square
                          size="sm"
                        >
                          <img
                            style="width:13px; height: 13px;"
                            src="../../assets/icons/down.png"
                            class="imagen"
                          />
                        </CButton>
                      </div>
                    </div>
                  </div>
                </td>
              </template>
              <template #fecha_inicial="{item, index: pos}">
                <td :class="buscarError(pos)" style="position:relative;">
                  <div class="d-flex align-items-top flex-wrap flex-sm-nowrap">
                    <CInput
                      v-model="item.fecha_inicial"
                      type="date"
                      :horizontal="{ input: 'input-130' }"
                      invalidFeedback="Campo requerido"
                      v-if="!sending[pos]"
                    />
                    <span v-else>
                      {{moment(item.fecha_inicial,'YYYY-MM-DD 00:00:00').format('DD/MM/YYYY')}}
                    </span>
                    <div class="btn-group flex-column">
                      <div class="divUbi">
                        <CButton

                          v-c-tooltip="{
                            content:
                              'Copiar la fecha inicial en las filas vacías hasta donde haya una fila con información',
                            placement:
                              pos == items.length - 1 ? 'left-end' : 'left'
                          }"
                          tabindex="-1"
                          class="buttonClonarUbi"
                          @click="clonarCelda(pos, 'fecha_inicial')"
                          color="ghost-light"
                          square
                          size="sm"
                        >
                          <img
                            style="width:13px; height: 13px;"
                            src="../../assets/icons/down.png"
                            class="imagen"
                          />
                        </CButton>
                      </div>
                    </div>
                  </div>
                </td>
              </template>
              <template #fecha_final="{item, index: pos}">
                <td :class="buscarError(pos)" style="position:relative;">
                  <div class="d-flex align-items-top flex-wrap flex-sm-nowrap">
                    <CInput
                      v-model="item.fecha_final"
                      type="date"
                      :horizontal="{ input: 'input-130' }"
                      invalidFeedback="Campo requerido"
                      v-if="!sending[pos]"
                    />
                    <span v-else>
                      {{moment(item.fecha_inicial,'YYYY-MM-DD 00:00:00').format('DD/MM/YYYY')}}
                    </span>
                    <div class="btn-group flex-column">
                      <div class="divUbi">
                        <CButton

                          v-c-tooltip="{
                            content:
                              'Copiar la fecha final en las filas vacías hasta donde haya una fila con información',
                            placement:
                              pos == items.length - 1 ? 'left-end' : 'left'
                          }"
                          tabindex="-1"
                          class="buttonClonarUbi"
                          @click="clonarCelda(pos, 'fecha_final')"
                          color="ghost-light"
                          square
                          size="sm"
                        >
                          <img
                            style="width:13px; height: 13px;"
                            src="../../assets/icons/down.png"
                            class="imagen"
                          />
                        </CButton>
                      </div>
                    </div>
                  </div>
                </td>
              </template>
              <template #concepto="{item, index: pos}">
                <td :class="buscarError(pos)" style="position:relative;">
                  <div class="d-flex align-items-top flex-wrap flex-sm-nowrap">
                    <CInput
                      v-model="item.concepto"
                      placeholder="Concepto"
                      v-if="!sending[pos]"
                    />
                    <span v-else>
                      {{item.concepto}}
                    </span>
                  <div class="btn-group flex-column">
                      <div class="divUbi">
                        <CButton

                          v-c-tooltip="{
                            content:
                              'Copiar el concepto en las filas vacías hasta donde haya una fila con información',
                            placement:
                              pos == items.length - 1 ? 'left-end' : 'left'
                          }"
                          tabindex="-1"
                          class="buttonClonarUbi"
                          @click="clonarCelda(pos, 'concepto')"
                          color="ghost-light"
                          square
                          size="sm"
                        >
                          <img
                            style="width:13px; height: 13px;"
                            src="../../assets/icons/down.png"
                            class="imagen"
                          />
                        </CButton>
                      </div>
                    </div>
                  </div>
                </td>
              </template>
              <template #monto="{item, index: pos}">
                <td :class="buscarError(pos)" style="position:relative;">
                  <div class="d-flex align-items-top flex-wrap flex-sm-nowrap">
                    <CInput
                      v-model="item.monto"
                      placeholder="Monto"
                      type="number"
                      v-if="!sending[pos]"
                    />
                    <span v-else>
                      {{$formatter(item.monto, true)}}
                    </span>
                    <div class="btn-group flex-column">
                      <div class="divUbi">
                        <CButton

                          v-c-tooltip="{
                            content:
                              'Copiar el monto en las filas vacías hasta donde haya una fila con información',
                            placement:
                              pos == items.length - 1 ? 'left-end' : 'left'
                          }"
                          tabindex="-1"
                          class="buttonClonarUbi"
                          @click="clonarCelda(pos, 'monto')"
                          color="ghost-light"
                          square
                          size="sm"
                        >
                          <img
                            style="width:13px; height: 13px;"
                            src="../../assets/icons/down.png"
                            class="imagen"
                          />
                        </CButton>
                      </div>
                    </div>
                  </div>
                </td>
              </template>
              <template #tipo_costo="{item, index: pos}">
                <td :class="buscarError(pos)" style="position:relative;">
                  <div class="d-flex align-items-top flex-wrap flex-sm-nowrap">
                    <Treeselect
                      v-model="item.tipo_costo"
                      :options="tiposCosto"
                      placeholder="Selecciona un tipo"
                      title="Selecciona un trabajador"
                      v-if="!sending[pos]"
                    >
                    </Treeselect>
                    <span v-else>
                      {{tiposCosto.find(f=>f.id === item.tipo_costo).label||''}}
                    </span>

                    <div class="btn-group flex-column">
                      <div class="divUbi">
                        <CButton

                          v-c-tooltip="{
                            content:
                              'Copiar el tipo costo en las filas vacías hasta donde haya una fila con información',
                            placement:
                              pos == items.length - 1 ? 'left-end' : 'left'
                          }"
                          tabindex="-1"
                          class="buttonClonarUbi"
                          @click="clonarCelda(pos, 'tipo_costo')"
                          color="ghost-light"
                          square
                          size="sm"
                        >
                          <img
                            style="width:13px; height: 13px;"
                            src="../../assets/icons/down.png"
                            class="imagen"
                          />
                        </CButton>
                      </div>
                    </div>
                  </div>
                </td>
              </template>
              <template #comentarios="{item, index: pos}">
                <td :class="buscarError(pos)" style="position:relative;">
                  <div class="d-flex align-items-top flex-wrap flex-sm-nowrap">
                    <CTextarea
                      v-model="item.comentarios"
                      :horizontal="{ input: 'input-130' }"
                      v-if="!sending[pos]"
                    />
                    <span v-else>
                      {{item.comentarios||' '}}
                    </span>
                    <div class="btn-group flex-column">
                      <div class="divUbi">
                        <CButton

                          v-c-tooltip="{
                            content:
                              'Copiar el comentario en las filas vacías hasta donde haya una fila con información',
                            placement:
                              pos == items.length - 1 ? 'left-end' : 'left'
                          }"
                          tabindex="-1"
                          class="buttonClonarUbi"
                          @click="clonarCelda(pos, 'comentarios')"
                          color="ghost-light"
                          square
                          size="sm"
                        >
                          <img
                            style="width:13px; height: 13px;"
                            src="../../assets/icons/down.png"
                            class="imagen"
                          />
                        </CButton>
                      </div>
                    </div>
                  </div>
                </td>
              </template>
              <template #trash="{index: pos}">
                <td :class="buscarError(pos)">
                  <div>
                    <CButton tabindex="-1" style="width: 20px; height: 20px; padding: 1px;" @click="borrarFila(pos)" color="ghost-light" square size="sm">
                      <!-- <CIcon style="width:15px; margin: 0px;" name="cil-trash" /> -->
                      <img style="width:15px; height: 15px;" src="../../assets/icons/trash.png" class="imagen" >
                    </CButton>
                  </div>
                </td>
              </template>

              <template #under-table>

                <CCol sm="12" md="9" lg="9">
                  <KlayFileDD
                    :fetching="fetching"
                    v-model="medias"
                    :label="`Anexos: `"
                    @onFetch="()=>{fetching=false}"
                    @onErrorFetch="(err)=>{
                      fetching=false;
                      error=err
                      warningModal=true
                    }"
                    :fetchMethod="pushMedia"
                    :baseSrc="$store.getters.MediaGet"
                  />
                </CCol>
                <div class="d-flex flex-wrap justify-content-evenly">
                  <router-link
                    :to="{ name: 'Bono', params: { config: config } }"
                  >
                    <CButton class="px-4 mx-3 btn-lg" color="danger"
                      >Cancelar</CButton
                    >
                  </router-link>
                  <CButton
                    v-if="isLoading"
                    class="px-4 mx-3 btn-lg"
                    color="success"
                  >
                    <div>
                      <div
                        class="w-100 d-flex justify-content-center align-items-center"
                      >
                        <div
                          class="sk-flow height-custom flex align-items-center"
                        >
                          <div class="sk-flow-dot bg-load-white"></div>
                          <div class="sk-flow-dot bg-load-white"></div>
                          <div class="sk-flow-dot bg-load-white"></div>
                        </div>
                      </div>
                    </div>
                  </CButton>
                  <CButton
                    v-else
                    @click="addDoc()"
                    class="px-4 mx-3 btn-lg"
                    color="success"
                  >
                    <span>Guardar</span>
                  </CButton>
                </div>
              </template>
            </CDataTable>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal size="lg" :show.sync="modalUbicaciones" :no-close-on-backdrop="true" :centered="false" title="Ubicaciones" color="info">
      <CDataTable
        hover
        bordered
        small
        fixed
        :loading="isLoading"
        :items="filteredItems"
        :fields="fieldsUbi"
        :noItemsView="noItems"
        style="height: 60vmin;"
        class="table-responsive"
      >
        <template #nombre="{item, index}">
          <td v-if="filter" class="py-2 ">
            {{ item.payload.nombre }}
          </td>
          <td
            v-else
            class="py-2"
            :class="
              `${
                ubicacionesJ.filter(hijo => hijo.payload.pertenece_id == item.id)
                  .length > 0
                  ? `cursor-p`
                  : ``
              }`
            "
            @click="toggleUbicaciones(index)"
          >
            <span>
              <CIcon
                v-if="
                  ubicacionesJ.filter(
                    hijo => hijo.payload.pertenece_id == item.id
                  ).length > 0
                "
                name="cil-chevron-circle-down-alt"
              />
            </span>
            {{ item.payload.nombre }}
          </td>
        </template>
        <template #details="{item, index}">
          <CCollapse :show="details.includes(index)">
            <TableCollapse
              :key="pos"
              @click-cancel="toggleCancel"
              @click-print="printNanoid"
              @clearCallback="cb=>clearCallback=cb"
              @setValueCallback="v=>ubicacionesSelec=v"
              :defaultValue="defaultValue"
              :ubicacionPadre="item.id"
              :cultivos="cultivos"
              :ubicaciones="
                ubicacionesJ.filter(hijo => hijo.payload.raiz_id == item.id)
              "
            ></TableCollapse>
          </CCollapse>
        </template>
      </CDataTable>
      <template #footer>
        <CButton @click="agregarUbicaciones()" color="info">Aceptar</CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      title="Cambiando ubicacion raiz"
      :centered="true"
      color="warning"
      :show.sync="rootModal"
      @click="confirmAct"
      @close="cancelAct"
      :no-close-on-backdrop="true"
    >
    <CRow>
      <CCol>
        Al cambiar la ubicación raiz durante la captura, la información del formulario será borrada, desea continuar?
      </CCol>
    </CRow>
    <template #footer>
      <CButton @click="confirmAct" color="success">Aceptar</CButton>
      <CButton @click="cancelAct" color="danger">Cancelar</CButton>
    </template>
    </CModal>
    <CModal
      size="sm"
      title="Labor"
      :centered="true"
      :closeOnBackdrop="false"
      color="info"
      :show.sync="successModal"
      class="text-center"
      >
      <span v-if="isLoading">
        ¡Un momento, la información se está guardando!.
      </span>
      <span v-else>La información se ha procesado</span>
      <template #footer>
        <CButton v-if="isLoading" class="px-4 mx-3 btn-lg" color="info">
            <div>
              <div class="w-100 d-flex justify-content-center align-items-center">
                <div class="sk-flow height-custom flex align-items-center">
                  <div class="sk-flow-dot bg-load-white"></div>
                  <div class="sk-flow-dot bg-load-white"></div>
                  <div class="sk-flow-dot bg-load-white"></div>
                </div>
              </div>
            </div>
          </CButton>
          <CButton v-else @click="revisarErrores()" class="px-4 mx-3 btn-lg" color="info">
            <span>Aceptar</span>
          </CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      title="Bono"
      :centered="true"
      color="warning"
      :show.sync="successModalBono"
      >Se limpiara la información de la tabla.
      <template #footer>
        <CButton @click="successModalBono = false"  color="secondary">Cancelar</CButton>
        <CButton @click="limpiarTabla"  color="warning">Aceptar</CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      title="Bono"
      :centered="true"
      color="info"
      :show.sync="modalCopiar"
      >Ya no hay espacios disponibles para poder copiar.
      <template #footer>
        <CButton @click="modalCopiar = false"  color="info">Aceptar</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from "moment"
import Treeselect from '@riophae/vue-treeselect'
import TableCollapse from "../../customComponents/TableCollapse1";
import {nanoid} from "nanoid";

const itemClear = {
  fechahora: "",
  trabajador_id: null,
  ubicaciones: [],
  fecha_inicial: "",
  fecha_final: "",
  concepto: "",
  monto: "",
  tipo_costo: null,
  comentarios: "",
}
//?'clear':'dirty'
const stringClearVal = v=>v===""
const stringVal = v=>v!==""
const nullClearVal = v=>!v
const nullVal = v=>!!v
const arrayClearVal = v=>(v?.length||0)===0
const arrayVal = v=>v?.length>0
const notVal = ()=>true

const itemDirtyFun = {
  fechahora: stringClearVal,
  trabajador_id: nullClearVal,
  ubicaciones: arrayClearVal,
  fecha_inicial: stringClearVal,
  fecha_final: stringClearVal,
  concepto: stringClearVal,
  monto: stringClearVal,
  tipo_costo: nullClearVal,
  comentarios: stringClearVal,
}
const itemValFun = {
  fechahora: stringVal,
  trabajador_id: nullVal,
  ubicaciones: arrayVal,
  fecha_inicial: stringVal,
  fecha_final: stringVal,
  concepto: stringVal,
  monto: stringVal,
  tipo_costo: nullVal,
  comentarios: notVal,
}

export default {
  name: "NuevoBonos",
  components: {
    Multiselect,
    TableCollapse,
    Treeselect,
  },
  data() {
    return {
      moment,
      clearCallback: ()=>{},
      ubiValueModal: ()=>{},
      defaultValue: [],
      trabajadores: [],
      pos: -1,
      config: this.$route.params.config,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      isLoading: false,
      enviado: true,
      successModalBono: false,
      successModal: false,
      isLoadingPage: false,
      modalCopiar: false,
      filter: "",
      items: new Array(20).fill({}).map(() => (JSON.parse(JSON.stringify(itemClear)))),
      tiposCosto:[{ id: 'cosecha', label: 'Cosecha' },{ id: 'no_cosecha', label: 'No cosecha' }],
      cultivos: [],
      details: [],
      rootModal: false,
      ubicacionRaizOld: {},
      errores: new Array(20).fill({}).map(()=>({showpop: false, error:{}, fail: undefined})),
      ubicacionesSelec: [],
      ubicacionesJ: [],
      ubicaciones: [],
      fieldsUbi: [
        { key: "nombre", label:"Ubicaciones", _style: "width:50%" },
      ],
      fields: [
        { key: "clonar", label: "", _style: "width:1%" },
        { key: "fechahora", label: "Fecha", _style: "min-width: 100px" },
        { key: "trabajador_id", label: "Trabajador", _style: "min-width: 150px" },
        { key: "ubicaciones", label: "Ubicaciones", _style: "min-width: 100px" },
        {
          key: "fecha_inicial",
          label: "Fecha inicial",
          _style: "min-width: 100px"
        },
        { key: "fecha_final", label: "Fecha final", _style: "min-width: 100px" },
        { key: "concepto", label: "Concepto", _style: "min-width: 150px" },
        { key: "monto", label: "Monto", _style: "min-width: 140px" },
        { key: "tipo_costo", label: "Tipo de costo", _style: "min-width: 140px" },
        { key: "comentarios", label: "Comentario", _style: "min-width: 100px" },
        { key: "trash", label: "", _style: "width:1%" },
      ],
      fetching: false,
      medias:[],
    };
  },
  computed: {
    sending(){
      return this.errores.map(error=>{
        return error.fail!== undefined && !error.fail
      })
    },
    itemsStatus(){
      return this.items.map(m=>{
        const item = {status: true}
        for(let key of Object.keys(itemDirtyFun)){
          const val = itemDirtyFun[key](m[key])
          item.status = item.status&&val
          item[key] = val
        }
        return item
      })
    },
    itemsVal(){
      return this.items.map(m=>{
        const item = {valid: true}
        for(let key of Object.keys(itemValFun)){
          const val = itemValFun[key](m[key])
          item.valid = item.valid&&val
          item[key] = val
        }
        return item
      })
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    filteredItems() {
      if (this.filter) {
        return this.ubicacionesJ.filter(i =>
          i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase())
        );
      } else {
        return this.ubicacionesJ.filter(i => i.payload.pertenece_id == 0);
        // .filter(i =>
        //   i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase())
        // );
      }
    },
    modalUbicaciones: {
      get(){
        return this.pos>=0
      },
      set(val){
        if(false === val){
          this.pos = -1
          this.ubicacionesSelec = []
          this.clearCallback()
        } else{
          this.pos = val
        }
      }
    }
  },
  watch: {
    ubicacionRaiz(newValue, oldValue) {
      if(this.itemsStatus.some(s=>!s.status)){
        if(newValue.value!==this.ubicacionRaizOld.value){
          this.rootModal = true
          this.ubicacionRaizOld = oldValue
        }
      }else{
        this.actualizarInfo()
      }
    }
  },
  created() {
    this.actualizarInfo()
  },
  methods: {
    confirmAct(){
      this.actualizarInfo();
      this.rootModal = false
      this.limpiarTabla()
    },
    cancelAct(){
      this.$store.dispatch("setRootLocation", this.ubicacionRaizOld);
      this.rootModal = false
    },
    revisarErrores() {
      this.successModal = false
      let error = this.errores.find(element => element.fail == true)
      if (!error) {
        this.limpiarTabla()
      }
    },
    async addDoc(){

      // this.errores = []
      this.enviado = false;
      this.successModal = true;
      console.log(this.items)

      this.fetching = true
      this.isLoading = true;

      await (new Promise((res)=>{
        const iter = setInterval(()=>{
          console.log(this.fetching)
          if(!this.fetching){
            this.error = ""
            clearInterval(iter)
            res()
          }
        },1000)
      }))
      this.isLoading = false;
      if(this.error){
        this.successModal = false;
        return
      }
      await this.agregar()
    },
    async agregar(){
      this.isLoading = true;
      const list = this.items.map((item,i)=>{
        if(!this.itemsStatus[i].status){
          if(this.sending[i]){
            return
          }
          if(this.itemsVal[i].valid){
            return {pos:i,item}
          } else {
            const obj = JSON.parse(JSON.stringify(this.itemsVal[i]))
            delete obj.valid
            this.errores[i].error = {message: `Los siguentes campos son requeridos: ${Object.keys(obj).filter((key)=>!obj[key]).map(key=>this.fields.find(f=>f.key===key)?.label||'').join(', ')}`}
            this.errores[i].fail = true
          }
        }
      })
      return Promise.all(list.filter(ff=>ff).map(async m=>{
        const nanoid_ = await nanoid(25)
        const {item, pos} = m
         return this.$store.dispatch("customDocumentoAddHTTP", {
          schema: "bonos",
          payload: {
            encabezado: {
              nanoid: nanoid_,
              fechahora: moment(item.fechahora,'YYYY-MM-DD 00:00:00').format('YYYY-MM-DD HH:mm:ss'),
              trabajador_id: item.trabajador_id,
              ubicaciones: item.ubicaciones.map(m=>m.value),
              fecha_inicial : item.fecha_inicial,
              fecha_final : item.fecha_final,
              concepto: item.concepto,
              monto: Number(item.monto),
              tipo_costo: item.tipo_costo,
              comentarios: item.comentarios || '',
              ubicacion_raiz_id: this.ubicacionRaiz
                ? this.ubicacionRaiz.value
                : null,
            },
            anexos: this.medias,
          },
        }).then(res => {
            return {pos,res};
          })
          .catch(rej => {

            // this.errores[pos].error = rej;
            // this.errores[pos].fail = true;
            return {pos,res:rej};
          })

      })).then(docs=>{
        docs.forEach(({pos,res}) => {
          if(res.status==="fail"){
            this.errores[pos].fail = true
            this.errores[pos].error = {message: res.message}
          } else {
            this.errores[pos].fail = false
            this.errores[pos].error = {}
          }
          this.errores[pos].showpop = false
        });
        debugger
        this.enviado = true
        this.isLoading = false;
        return
      })
    },
    async pushMedia(files) {
      const arr = [];

      for (const v of files.map(async (m) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if(!!m.media){
          return Promise.resolve({data:m,status:"success"})
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;

        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    borrarFila(pos){
      Object.keys(itemClear).forEach(key=>{
        if(itemClear[key] === null){
          this.items[pos][key] = null
        } else{
          this.items[pos][key] = itemClear[key]
        }
      })
      this.errores[pos].error = {}
      this.errores[pos].fail = undefined
      this.errores[pos].showpop = false
    },
    limpiarTabla() {
      this.successModalBono = false
      for(let pos in this.items){
        this.borrarFila(pos)
      }
    },
    clonarCelda(pos,key){
      if(this.itemsStatus[pos][key]){
        return
      }
      const item = this.items[pos][key]
      let pointer = pos + 1
      console.log((pointer<this.items.length),this.itemsStatus[pointer][key])
      while((pointer<this.items.length)&&this.itemsStatus[pointer][key]){
        this.items[pointer][key] = item
        pointer++
      }
    },
    copyAll(pos){
      let item = JSON.parse(JSON.stringify(this.items?.[pos]||{}))
      if(!this.itemsStatus[pos].status){
        console.log(this.items.slice(pos).some((s,i)=>this.itemsStatus[pos+i].status))
        if(!this.items.slice(pos).some((s,i)=>this.itemsStatus[pos+i].status)){
          this.modalCopiar = true
          return
        }
        let pointer = pos
        let aux = {}
        do{
          if(Object.keys(this.items?.[pointer+1]||{}).length>0){
            aux = JSON.parse(JSON.stringify(this.items?.[pointer+1]||{}))
          }
          Object.keys(item).forEach(key=>{
            this.items[pointer+1][key] = item[key]
          })
          item = aux
          aux = {}
          pointer++
          this.$forceUpdate();
        }while((pointer<this.items.length-1)&&Object.keys(item).length>0)
      }

    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        name: item.payload.nombre,
        index: this.items.indexOf(item)
      };
      this.itemModal = itemIndex;
    },
    onResultados(datos) {
      let ids = datos.payload.ruta.slice(1,-1).split('/')
      let exist = false;
      ids.forEach(ubicacionId => {
        if (this.ubicacionesSelec.find( ubicacion => ubicacion.value == ubicacionId) && ubicacionId != ids[ids.length - 1]) {
          this.modalUbicacionPadre = true
          exist = true
        }
      });

      if (exist == false) {
        this.ubicacionesSelec.forEach(ubicacion => {
          let ubicacionesRuta = ubicacion.ruta.slice(1,-2).split('/')
          ubicacionesRuta.forEach(ubicacionRuta => {
            if (ubicacionRuta == datos.id) {
              this.modalUbicacionPadre = true
              exist = true
            }
          });
        });
      }

      if (datos.selected && exist == false) {
        if (!this.ubicacionesSelec.find( ubicacion => ubicacion.value == datos.id )) {
          this.ubicacionesSelec.push({value: datos.id, label: datos.payload.nombre, ruta: datos.payload.ruta})
        }
      }else{
        this.ubicacionesSelec = this.ubicacionesSelec.filter(ubicacion => ubicacion.value != datos.id)
      }

    },
    printNanoid(ubicacion, cant) {

      if (ubicacion && cant && cant > 0) {
        window.printTicket(
          `^XA^CFA,25^FO25,165^FD${ubicacion.payload.nombre}^FS^FO20,20^BY3^BCN,100,Y,N, ^FD${ubicacion.payload.nanoid}^PQ${cant}^XZ`
        );
      }
      //window.printTicket(`^XA^FO20,20^BY3^BCN,100,Y,N,N^FDUb03b201^XZ`);
    },
    actualizarInfo() {
      this.isLoadingPage = true;
      const ubi = [
        this.$store.dispatch("customHTTP", {
          schema: "actividades_costos",
          filter: {
            where: [
              {
                field: "payload->ubicacion_id",
                operator: "regexp",
                value: `[[:<:]]${this.ubicacionRaizValue}[[:>:]]`
              }
            ]
          },
          order: [
            {
              field: "payload->nombre",
              direction: "asc"
            }
          ],
        }),
        this.$store.dispatch("customHTTP", {
          schema: "trabajadores",
          filter: {
            where: [
              {
                field: "payload->ubicaciones",
                operator: "regexp",
                value: `[[:<:]]${this.ubicacionRaizValue}[[:>:]]`
              },
              {
                  field: "payload->suspendido",
                  operator: "=",
                  value: false
              }
            ]
          },
          order: [
            {
              field: "payload->nombre",
              direction: "asc"
            }
          ],
        }),
        this.$store.dispatch("customHTTP", {
          schema: "actividades",
          order: [
            {
              field: "payload->pertenece_id",
              direction: "asc"
            }
          ],
          _filter: {
            where: [
              {
                field: "payload->unidad",
                value: "",
                operator: "!="
              }
            ]
          }
        })
      ];

      if (this.ubicacionRaizValue) {
        ubi.push(this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->raiz_id",
              value: this.ubicacionRaizValue,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      }));
      } else {
        ubi.push(this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        }));
      }

      Promise.all(ubi)
        .then(([actividades_costos, trabajadores, actividades, ubicaciones]) => {
          this.actividades_costos = actividades_costos.data
          this.trabajadores = trabajadores.data.map(trabajador => {
            return { id: trabajador.id, label: trabajador.payload.nombre };
          });
          this.actividades = actividades.data.map(actividad => {
            return { id: actividad.id, label: actividad.payload.nombre, unidad: actividad.payload.unidad};
          });

          this.ubicaciones = ubicaciones.data.map(ubicacion => {
            return { value: ubicacion.id, label: ubicacion.payload.nombre };
          });

          this.ubicacionesJ = ubicaciones.data
              ? ubicaciones.data.map(ubi => {
                  return { ...ubi, selected: false };
                })
              : [];

          function clearDeep(item){
            if(item.children.length){
              item.children=item.children.map(clearDeep)
            } else{
              delete item.children
            }
            return item
          }
          this.optionsGroup = actividades.data
          .sort((a,b)=>a.payload.ruta.split('/').length-b.payload.ruta.split('/').length)
          .reduce((v,c)=>{
            c.payload.ruta
            .split('/').slice(1,-2).map(Number)
            .reduce((pointer,id)=>pointer.find(f=>f.id===id).children,v)
            .push({
              id: c.id,
              label: c.payload.nombre,
              tipo_pago: c.payload.tipo_pago,
              tipo: c.payload.tipo,
              children: [],
            })
            return v
          }, [])
          .map(clearDeep)

          this.ubicacionesAll = ubicaciones.data;
          this.trabajadoresAll = trabajadores.data;
          this.actividadesAll = actividades.data;
        })
        .finally(() => (this.isLoadingPage = false));
    },
    agregarUbicaciones() {
      this.items[this.pos].ubicaciones = this.ubicacionesSelec
      this.$store.dispatch('updateStatus', true)
      this.details = []
      this.modalUbicaciones = false
    },
    obtenerUbicaciones(pos) {
      this.$store.dispatch('updateStatus', false)
      // this.details = []
      this.modalUbicaciones = pos
      console.log(this.items[pos])
      this.defaultValue = this.items[pos].ubicaciones
      this.$store.state.count = []
    },
    toggleUbicaciones(index) {
      const position = this.details.indexOf(index);
      position !== -1
        ? this.details.splice(position, 1)
        : this.details.push(index);
    },
    buscarError(pos) {
      if (this.errores[pos].fail !== undefined) {
        return this.errores?.[pos]?.fail
          ? "table-danger"
          : this.enviado
          ? "table-success"
          : "";
      }
    },
    getDate(date) {
      if (date === undefined || date === "") {
        return "N/A";
      }
      let newDate = moment(date, "YYYY-MM-DD 00:00:00");
      return newDate.format("DD/MM/YYYY");
    },
    mostrarPop(pos) {
      this.errores[pos].showpop = !this.errores[pos].showpop;
    },
    mensajeError(pos) {
      let error = this.errores[pos];
      let msg = "";
      if (error) {
        if (error.error) {
          switch (error.error.message) {
            case "Los datos dados no eran válidos.":
              msg = "Algunos datos son requeridos";
              break;
            case "El campo fechahora es invalido.":
              msg = "La fecha ingresada es invalida";
              break;
            default:
              msg = error.error.message;
              break;
          }
        }
      }
      return msg;
    }
  }
};
</script>
<style src="../../assets/scss/multiselect.css"></style>
<style src="../../assets/scss/vue-select.css"></style>
<!-- <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->
<style src="../../assets/scss/tree-select.css"></style>
<style src="spinkit/spinkit.min.css"></style>
<style lang="scss" scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
</style>
<style lang="scss">
.height-custom {
  height: 25px;
}
.bg-load-white {
  background-color: white !important;
}
.input-130{
  width: 130px;
}

.table-masiva{
  .table-responsive{
    max-height: calc(100vh - 60px - 64px - 140px - 40px);
  }
}
.popUp{
  position:absolute;
  display: block;
  width: 300px;
  z-index: 2;
  background-color: rgb(255, 0, 0);
  border-radius: 10px;
  color: white;
  padding: 10px;
  margin-left: 20%;
  margin-top: 35px;
}
</style>
